<template>
    <div class="buttonlist">
        <div class="buttonlist-m">
            <el-form :inline="true" :model="formInline" class="demo-form-inline toolbar" style="padding-bottom: 0px" @submit.native.prevent>
                <el-form-item label="姓名">
                    <el-input
                        clearable
                        style="width: 160px"
                        v-model.trim="formInline.name"
                        placeholder="请输入姓名"
                        @keyup.enter.native.prevent="enterSearch"
                    ></el-input>
                </el-form-item>
                <el-form-item label="性别">
                    <el-select v-model="formInline.sex" style="width: 160px" clearable>
                        <el-option value="0" label="男"></el-option>
                        <el-option value="1" label="女"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="证件类型">
                    <el-select v-model="formInline.idCardType" style="width: 160px" clearable>
                        <el-option value="ID_CARD" label="身份证"></el-option>
                        <el-option value="PASSPORT" label="护照"></el-option>
                        <el-option value="OTHER" label="其他"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="证件号码" label-width="90px">
                    <el-input clearable style="width: 180px" v-model.trim="formInline.idCardNo" placeholder="请输入证件号码"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="search" plain>搜索</el-button>
                    <el-button type="warning" icon="el-icon-plus" @click="addFace" plain>新增</el-button>
                    <!-- 仅保留扫码添加按钮，无其他依赖 -->
                    <el-button type="success" icon="el-icon-scan" @click="scanAdd" plain>扫码添加</el-button>
                </el-form-item>
            </el-form>
            <div v-loading="loading" element-loading-text="拼命加载中......"></div>
            <el-table :data="tableData" style="width: 100%" :header-cell-style="tableHeaderColor" :row-style="tableRowStyle">
                <el-table-column label="序号" align="center" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <span style="margin-left: 10px">{{ scope.row.deviceNo }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="姓名" min-width="90" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="sex" label="性别" width="60" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <p>{{ scope.row.sex == 0 ? '男' : '女' }}</p>
                    </template>
                </el-table-column>
                <el-table-column prop="faceInfo" label="人脸信息" min-width="120" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <div v-if="scope.row.faceUrl">
                            <el-image :src="scope.row.faceUrl" style="width: 40px; height: 40px; border-radius: 4px" fit="cover"></el-image>
                        </div>
                        <span v-else>无</span>
                    </template>
                </el-table-column>
                <el-table-column prop="idCardType" label="证件类型" min-width="100" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <p>
                            {{ scope.row.idCardType === 'ID_CARD' ? '身份证' : scope.row.idCardType === 'PASSPORT' ? '护照' : '其他' }}
                        </p>
                    </template>
                </el-table-column>
                <el-table-column prop="idCardNo" label="证件号码" min-width="180" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="idCardPhoto" label="证件照片" min-width="120" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <div v-if="scope.row.idCardPhotoUrl">
                            <el-image
                                :src="scope.row.idCardPhotoUrl"
                                style="width: 40px; height: 40px; border-radius: 4px"
                                fit="cover"
                            ></el-image>
                        </div>
                        <span v-else>无</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="remark"
                    label="备注"
                    show-overflow-tooltip
                    min-width="120"
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column label="操作" min-width="120">
                    <template slot-scope="scope">
                        <a @click="handleEdit(scope.$index, scope.row)" class="cursor">编辑</a>
                        <a @click="handleDelete(scope.$index, scope.row)" class="cursor" style="margin-left: 15px; color: #f56c6c">删除</a>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                layout="total, prev, pager, next"
                :total="totalDataNumber"
                :page-size="pageSize"
                align="center"
                class="fenye"
            ></el-pagination>
        </div>
    </div>
</template>

<script>
import bus from '@/vuex/eventBus';

export default {
    name: 'FaceLibraryManager',
    data() {
        return {
            formInline: {
                name: '',
                sex: '',
                idCardType: '',
                idCardNo: ''
            },
            tableData: [],
            tableLoading: false,
            currentPage: 1,
            pageNo: 1,
            pageSize: 10,
            totalDataNumber: 0
        };
    },
    methods: {
        tableRowStyle({ row, rowIndex }) {
            if (rowIndex % 2 === 0) {
                return 'background-color: #ffffff';
            } else {
                return 'background-color: #e4f5f8';
            }
        },
        // 回车搜索
        enterSearch(e) {
            const keyCode = window.event ? e.keyCode : e.which;
            if (keyCode === 13) {
                this.search();
            }
        },
        // 搜索
        search() {
            this.pageNo = 1;
            this.queryFaceList();
        },
        // 查询人脸库列表
        queryFaceList() {
            const params = {};
            if (this.formInline.name) params.name = this.formInline.name;
            if (this.formInline.sex) params.sex = this.formInline.sex;
            if (this.formInline.idCardType) params.idCardType = this.formInline.idCardType;
            if (this.formInline.idCardNo) params.idCardNo = this.formInline.idCardNo;

            params.pageNo = String(this.pageNo);
            params.pageSize = String(this.pageSize);

            this.tableData = [];
            this.tableLoading = true;

            this.$postJson('omc/FaceLibrary/showFaceList', params).then((res) => {
                if (res.code === 200) {
                    if (res.result.list) {
                        this.pageSize = res.result.pageSize;
                        this.currentPage = res.result.pageNum;
                        this.totalDataNumber = res.result.total * 1;
                        this.tableData = res.result.list;
                    } else {
                        this.tableData = [];
                        this.pageSize = 10;
                        this.currentPage = 1;
                        this.totalDataNumber = 0;
                    }
                } else {
                    this.tableData = [];
                    this.pageSize = 10;
                    this.currentPage = 1;
                    this.totalDataNumber = 0;
                }
                setTimeout(() => {
                    this.tableLoading = false;
                }, 500);
            });
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.queryFaceList();
        },
        handleCurrentChange(val) {
            this.pageNo = val;
            this.queryFaceList();
        },
        // 新增人脸
        addFace() {
            bus.$emit('homePage', {
                type: 'jump',
                path: '/faceLibraryAdd',
                title: '新增人脸信息'
            });
        },
        // 扫码添加（仅保留提示，无任何依赖）
        scanAdd() {
            this.$message.info('扫码添加功能待开发，暂请使用【新增】按钮录入人脸信息');
        },
        // 编辑
        handleEdit(index, row) {
            sessionStorage.setItem('faceLibraryId', row.id);
            bus.$emit('homePage', {
                type: 'jump',
                path: '/faceLibraryEdit',
                title: '编辑人脸信息'
            });
        },
        // 删除
        handleDelete(index, row) {
            this.$confirm('确定要删除该人脸信息吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    this.$postJson('omc/FaceLibrary/deleteFace', { id: row.id }).then((res) => {
                        if (res.code === 200) {
                            this.$message.success('删除成功');
                            this.queryFaceList();
                        } else {
                            this.$message.error(res.msg || '删除失败');
                        }
                    });
                })
                .catch(() => {
                    this.$message.info('已取消删除');
                });
        },
        // 修改table header的背景色
        tableHeaderColor({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'color:#2d2d2d;font-weight: 600; text-align: center;font-size: 16px;background-color: #d4f5fa;';
            }
        }
    },
    mounted() {
        this.queryFaceList();
    }
};
</script>

<style lang="scss" scoped>
.buttonlist {
    .buttonlist-m {
        padding: 10px 0 0 5px;
    }
}
.fenye {
    padding: 10px 0;
    margin: 0 auto;
    background: #fff;
}
.cursor {
    cursor: pointer;
}
</style>
